import { reatomAsync } from '@reatom/async';
import { BACKEND_API } from '@trwl/backend.api';
import { handleErrorToast } from '@trwl/util';
import { toast } from 'sonner';

export const deleteAccountAction = reatomAsync(
  () =>
    BACKEND_API.AuthApi.deleteMe()
      .then(() => {
        toast.success(
          'На вашу почту отправленно письмо с подтверждением действия',
          {
            id: 'DeleteAccountRequest',
          },
        );
      })
      .catch(handleErrorToast),
  'deleteAccountAction',
);
